import useMutation from "src/hooks/useMutation";

function useOrderConfirmAllTS() {
  return useMutation({
    path: "/api/v1/orders/tracking-status",
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/orders`,
      shouldRevalidate: true,
    },
  });
}

export default useOrderConfirmAllTS;
